import React from 'react';
import { Form } from 'react-form';
import PropTypes from 'prop-types';

import { Input } from '../../components/Form';

import { createReactFormValidator, numeric, range } from '../../utils/validation';

import styles from './PlayersTabV3/playersTab.scss';
import { isPickleBallSportTypeEvent } from '../../utils/events';
import { sportTypeIds } from '../../utils/eventConstants';

const SetOrganizerRatingForm = (props) => {
    const {
        ratingValue,
        closeForm,
        setOrganizerRating,
        sportTypeId,
        'data-testid': dataTestId,
    } = props;

    const validatorRange = isPickleBallSportTypeEvent(sportTypeId) ? [numeric, range(0, 10)] : [numeric, range(0, 16)];

     return (
        <Form
            onSubmit={values => setOrganizerRating(values)}
        >
            {(formApi) => {
                const { submitForm, getError } = formApi;
                const error = getError('rating');
                return (
                    <form onSubmit={submitForm}>
                        <div className={`row ${styles.setOrgRatingWrap}`}>
                            <div className={`d-flex flex-column ${styles.setOrgRatingForm}`}>
                                <div className="d-flex flex-row">
                                    <div className={styles.setOrgRatingInput}>
                                        <Input
                                            placeholder={ratingValue}
                                            field="rating"
                                            type="text"
                                            autoFocus="autoFocus"
                                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
                                            validate={createReactFormValidator(validatorRange)}
                                        />
                                    </div>
                                    <div className={`${styles.setOrgRatingEdit}`} onClick={(e) => { e.stopPropagation(); closeForm(); }} data-testid={dataTestId && `${dataTestId}.close-btn`}>
                                        <i className="fa fa-window-close fa-2x" />
                                    </div>
                                    <div className={`${styles.setOrgRatingEdit}`} onClick={(e) => { e.stopPropagation(); submitForm(); }} data-testid={dataTestId && `${dataTestId}.submit-btn`}>
                                        <i className="fa fa-check-square fa-2x" />
                                    </div>
                                </div>
                                {(error && <div className={styles.setOrgRatingError} data-testid={dataTestId && `${dataTestId}.error`}>{error}</div>)}
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

SetOrganizerRatingForm.propTypes = {
    ratingValue: PropTypes.number,
    closeForm: PropTypes.func.isRequired,
    setOrganizerRating: PropTypes.func.isRequired,
    sportTypeId: PropTypes.number,
    'data-testid': PropTypes.string,
};

SetOrganizerRatingForm.defaultProps = {
    ratingValue: null,
    sportTypeId: sportTypeIds.TENNIS,
    'data-testid': undefined,
};

export default SetOrganizerRatingForm;
